/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TailoredDefragSummaryEventsMovedList_eventsMoved = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryEventMoved_eventMoved">;
    readonly " $refType": "TailoredDefragSummaryEventsMovedList_eventsMoved";
}>;
export type TailoredDefragSummaryEventsMovedList_eventsMoved$data = TailoredDefragSummaryEventsMovedList_eventsMoved;
export type TailoredDefragSummaryEventsMovedList_eventsMoved$key = ReadonlyArray<{
    readonly " $data"?: TailoredDefragSummaryEventsMovedList_eventsMoved$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryEventsMovedList_eventsMoved">;
}>;



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "TailoredDefragSummaryEventsMovedList_eventsMoved",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TailoredDefragSummaryEventMoved_eventMoved"
        }
    ],
    "type": "DefragExplainedMove",
    "abstractKey": null
} as any;
(node as any).hash = '5bd523d1afa28ee4fb3cdcf99470998f';
export default node;
